export const MAX_DISPLAY_ISSUE_COUNT = 100;

export enum SIGNAL_SEVERITY {
  CRITICAL = 'CRITICAL',
  MODERATE = 'MODERATE',
  LOW = 'LOW',
}

export enum SIGNAL_PERIOD {
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
}

export enum SIGNAL_DATE_PRESET {
  PAST_24_HOURS = 'Past 24 hours',
  PAST_3_DAYS = 'Past 3 days',
  PAST_7_DAYS = 'Past 7 days',
  PAST_30_DAYS = 'Past 30 days',
  PAST_90_DAYS = 'Past 90 days',
}

export const MAX_SIGNAL_CUSTOM_RANGE_DAYS = 90;
